import type { MembershipPlanName } from '@/utils/membershipPlans';

// Carries the chosen plan across a redirect-based payment, which reloads the app on return.
// Both keys are in SESSION_PERSISTENT_KEYS (utils/storageUtils.ts) so the beforeunload wipe
// that runs when a signed-in voter leaves for the payment page keeps them.
export const CHECKOUT_PLAN_KEY = 'votemate_membership_checkout';
const KEY = CHECKOUT_PLAN_KEY;
// A redirect payment whose status hasn't been confirmed yet; a reload reopens its check.
export const PENDING_SESSION_KEY = 'votemate_membership_pending_session';

export interface CheckoutPlanMemo {
  plan: MembershipPlanName;
  source: string | null;
  /** One-time gifts only. */
  amount_cents?: number;
}

export function rememberCheckoutPlan(memo: CheckoutPlanMemo) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(memo));
  } catch {
    // Storage blocked: the completion event just goes out without plan details.
  }
}

export function takeCheckoutPlan(): CheckoutPlanMemo | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return raw ? (JSON.parse(raw) as CheckoutPlanMemo) : null;
  } catch {
    return null;
  }
}

export function rememberPendingSession(sessionId: string) {
  try {
    sessionStorage.setItem(PENDING_SESSION_KEY, sessionId);
  } catch {
    // Storage blocked: a reload mid-check just won't reopen it.
  }
}

export function readPendingSession(): string | null {
  try {
    return sessionStorage.getItem(PENDING_SESSION_KEY);
  } catch {
    return null;
  }
}

export function clearPendingSession() {
  try {
    sessionStorage.removeItem(PENDING_SESSION_KEY);
  } catch {
    // Nothing to clear.
  }
}
